module.exports = __webpack_public_path__ + "static/media/profile-arrow.6e537a5d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onBoardingArrows/profile-arrow.svg
// module id = 924
// module chunks = 21